import {combineReducers, configureStore, ThunkDispatch, UnknownAction} from '@reduxjs/toolkit';
import {Dispatch} from 'redux';
import brandGuidelinesPageReducer from 'common/src/modules/brandGuidelines/store/brandGuidelinesPage.slice';
import campaignPageReducer from 'common/src/modules/campaigns/store/campaignPage.slice';
import campaignsLibraryReducer from 'common/src/modules/campaigns/store/campaignsLibrary/campaignsLibrary.slice';
import copilotReducer from 'common/src/modules/shared/copilot/store/copilot.slice';
import targetPlatformsReducer from 'common/src/modules/targetPlatform/store/targetPlatforms.slice';
import {FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE} from 'redux-persist';
import assetsLibraryPageReducer from '../modules/Assets/store/assetsLibraryPage.slice';
import catalogFeedTabReducer from '../modules/catalogFeed/store/catalogFeed.slice';
import contentFeedPageReducer from '../modules/contentFeeds/store/contentFeedPage/contentFeedPage.slice';
import creativePageReducer from '../modules/creatives/store/creativePage/creativePage.slice';
import creativesLibraryReducer from '../modules/creatives/store/creativesLibrary/creativesLibrary.slice';
import creativeTemplatePageReducer from '../modules/creativeTemplates/store/creativeTemplatePage/creativeTemplatePage.slice';
import creativeTemplatesLibraryReducer from '../modules/creativeTemplates/store/creativeTemplatesLibrary/creativeTemplatesLibrary.slice';
import creativeWidgetPageReducer from '../modules/creativeTemplates/store/creativeWidgetPage/creativeWidgetPage.slice';
import dashboardReducer from '../modules/dashboards/store/dashboardPage.slice';
import creativeWidgetsTableReducer from '../modules/dynamicParameters/widgets/store/creativeWidgetsTable.slice';
import smartCreativePageReducer from '../modules/smartCreative/store/smartCreativePage/smartCreativePage.slice';
import smartCreativesLibraryReducer from '../modules/smartCreative/store/smartCreativesLibrary/smartCreativesLibrary.slice';
import applicationReducer from './application.slice';
import librariesReducer from './libraries.slice';
import luxonDateTimeMiddleware from './middlewares/luxonDateTimeMiddleware/luxonDateTimeMiddleware';

const rootReducer = combineReducers({
  application: applicationReducer,
  libraries: librariesReducer,
  copilot: copilotReducer,
  contentFeedPage: contentFeedPageReducer,
  campaignPage: campaignPageReducer,
  creativeWidgetsTable: creativeWidgetsTableReducer,
  campaignsLibrary: campaignsLibraryReducer,
  creativeTemplatesLibrary: creativeTemplatesLibraryReducer,
  creativeTemplatePage: creativeTemplatePageReducer,
  smartCreativesLibrary: smartCreativesLibraryReducer,
  smartCreativePage: smartCreativePageReducer,
  creativeWidgetPage: creativeWidgetPageReducer,
  creativesLibrary: creativesLibraryReducer,
  creativePage: creativePageReducer,
  targetPlatforms: targetPlatformsReducer,
  brandGuidelinesPage: brandGuidelinesPageReducer,
  assetsLibraryPage: assetsLibraryPageReducer,
  dashboard: dashboardReducer,
  catalogFeed: catalogFeedTabReducer,
  dashboardPage: dashboardReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).prepend(luxonDateTimeMiddleware),
});

const persistor = persistStore(store);

// Define the RootState and AppDispatch types
export type RootState = ReturnType<typeof rootReducer>;
export type CLDispatch = ThunkDispatch<RootState, undefined, UnknownAction> & Dispatch<UnknownAction>;

export type CLStore = {
  getState: () => RootState;
  dispatch: CLDispatch;
};

export {persistor, store};
